"use client";

import Button from "component/design-system/buttons/Button";
import NextImage from "component/design-system/images/NextImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { MessageCircle, Truck } from "lucide-react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { scrollToTop } from "util/scroll-helper";
import styles from "./perk-card.module.scss";

function PerkCard(props: any) {
  const {
    imgSrc,
    title,
    heading,
    buttonText,
    buttonUrl,
    buttonAction,
    alt,
    color,
    ctaIcon,
  } = props;
  const { t } = useTranslation("common");
  const router = useRouter();

  return (
    <div className={`${styles.perk_card} ${styles[color]}`}>

      <NextImage
        src={imgSrc}
        alt={alt}
        width={100}
        height={100}
        title={alt}
        className={styles.perk_card_image}
      />

      <div className={styles.text_container}>

        <PAText component="p" fontSize={FONT_SIZE[5]} className={`m-b-0 ${styles.text}`} bold>
          {t(title)}
        </PAText>

        <PAText component="p" fontSize={FONT_SIZE[2]} className={`${styles.text}  m-r-10`}>
          {t(heading)}
        </PAText>

        <Button
          onClick={() => {
            if (buttonAction) {
              buttonAction();
            } else {
              router.push(`${buttonUrl}`)
                .then(() => scrollToTop());
            }
          }}
          variant="neutral-outline"
          size="sm"
          fullWidth
          leftIcon={ctaIcon === "chat" ? <MessageCircle size={20} /> : <Truck size={20} />}
        >
          {t(buttonText)}
        </Button>
      </div>
    </div>
  );
}
export default PerkCard;
